var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_star/on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "129.438199%",
    y1: "6.0546875%",
    x2: "-16.1710452%",
    y2: "67.9744152%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA00",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE7714",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "54_Favorites",
    transform: "translate(-301, -263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(281, 240)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 1)",
    id: "ic_star/on"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 22)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99998737,0.4375 C7.37029878,0.4375 7.7063978,0.616795536 7.90600144,0.913226015 L7.97428814,1.02975674 L9.45095596,3.95589882 C9.51208934,4.07710151 9.6302561,4.16104367 9.76698954,4.18047261 L13.0689588,4.64970111 C13.4812258,4.70828133 13.8172594,4.98537194 13.9460261,5.37284242 C14.0747262,5.76031289 13.9694262,6.17764396 13.6711259,6.46203672 L11.2817907,8.73975417 C11.182824,8.83409537 11.1376906,8.96993497 11.1610573,9.10310146 L11.7251244,12.3192433 C11.7955245,12.7207965 11.6299243,13.1190246 11.2928574,13.3584961 C10.9558238,13.597935 10.5173901,13.6288388 10.1487232,13.4393088 L7.19535419,11.9208522 C7.07302076,11.8579363 6.92702065,11.8579689 6.80465389,11.9208522 L3.85131824,13.4393088 C3.69095145,13.5217514 3.51738465,13.5625 3.34471784,13.5625 C3.12041767,13.5625 2.89761749,13.4937815 2.70718401,13.3584309 C2.37015041,13.1189594 2.20451695,12.7207639 2.27495034,12.3192107 L2.83898411,9.10306886 C2.8623508,8.96986977 2.81721743,8.83403017 2.71825069,8.73972157 L0.328915482,6.46203672 C0.0306152484,6.17764396 -0.0747515008,5.76031289 0.0539819334,5.37284242 C0.182715368,4.98537194 0.518782297,4.70828133 0.931049287,4.64970111 L4.23301854,4.18047261 C4.36978531,4.16104367 4.48791874,4.07710151 4.54908545,3.95589882 L6.02575328,1.02975674 C6.21012009,0.664420913 6.58342038,0.4375 6.99998737,0.4375 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStart);
export default __webpack_public_path__ + "static/media/ic_start.d85922a67071e442526686e66263fb27.svg";
export { ForwardRef as ReactComponent };